import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { UrgencyBar } from './components/UrgencyBar';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-[#d4a017] selection:text-[#1e3a5f]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProofBar data-id="element-4" />
        <PainPoints data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <TomosSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <UrgencyBar data-id="element-9" />
        <PricingSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
    </div>;
}